import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import LmsCodeDropdown from '../../components/LmsCodeDropdown';
import LmsCodeMultiSelect from '../../components/LmsCodeMultiSelect';
import { useLanguage } from '../../../../contexts/LanguageContext';

const VehicleTrainingMatchForm = ({
    visible,
    onHide,
    formik,
    loading,
    selectedMatch,
    deleting,
    onDelete,
    readOnly = false
}) => {
    const { th } = useLanguage();

    const footer = (
        <div>
            {selectedMatch?.id && onDelete && (
                <Button
                    type="button"
                    label={th('common.delete')}
                    icon="pi pi-trash"
                    severity="danger"
                    disabled={loading || deleting}
                    onClick={() =>
                        confirmDialog({
                            message: th('vehicleTrainingMatch.confirmDelete'),
                            header: th('common.delete'),
                            icon: 'pi pi-exclamation-triangle',
                            acceptClassName: 'p-button-danger',
                            accept: () => onDelete(selectedMatch)
                        })
                    }
                />
            )}

            <Button
                type="button"
                label={th('common.cancel')}
                icon="pi pi-times"
                outlined
                onClick={onHide}
                disabled={loading}
            />

            {!readOnly && (
                <Button
                    type="button"
                    label={th('common.save')}
                    icon="pi pi-check"
                    onClick={formik.submitForm}
                    loading={loading}
                />
            )}
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={th(
                selectedMatch?.id
                    ? 'vehicleTrainingMatch.editTitle'
                    : 'vehicleTrainingMatch.addTitle'
            )}
            footer={footer}
            modal
            className="p-fluid"
            style={{ width: '36rem' }}
        >
            <div className="field mb-4">
                <label htmlFor="vehicleCode">
                    {th('vehicleTrainingMatch.vehicleModel')}{' '}
                    <span className="text-red-500">*</span>
                </label>

                <LmsCodeDropdown
                    id="vehicleCode"
                    groupCode="VEHICLE_MODEL"
                    value={formik.values.vehicleCode}
                    onChange={(value) =>
                        formik.setFieldValue('vehicleCode', value)
                    }
                    placeholder={th('vehicleTrainingMatch.selectVehicle')}
                    disabled={Boolean(selectedMatch?.id)}
                    invalid={
                        formik.touched.vehicleCode &&
                        Boolean(formik.errors.vehicleCode)
                    }
                    className="w-full"
                />

                {formik.touched.vehicleCode &&
                    formik.errors.vehicleCode && (
                        <small className="p-error">
                            {formik.errors.vehicleCode}
                        </small>
                    )}
            </div>

            <div className="field mb-0">
                <label htmlFor="trainingCodes">
                    {th('vehicleTrainingMatch.trainingType')}{' '}
                    <span className="text-red-500">*</span>
                </label>

                <LmsCodeMultiSelect
                    id="trainingCodes"
                    groupCode="TRAINING_TYPES"
                    value={formik.values.trainingCodes}
                    onChange={(value) =>
                        formik.setFieldValue('trainingCodes', value)
                    }
                    placeholder={th('vehicleTrainingMatch.selectTraining')}
                    invalid={
                        formik.touched.trainingCodes &&
                        Boolean(formik.errors.trainingCodes)
                    }
                    className="w-full"
                />

                {formik.touched.trainingCodes &&
                    formik.errors.trainingCodes && (
                        <small className="p-error">
                            {formik.errors.trainingCodes}
                        </small>
                    )}
            </div>
        </Dialog>
    );
};

export default VehicleTrainingMatchForm;